/**
 * Which lines open and close a MethodScript block.
 *
 * Folding is implemented per host (VS Code and Monaco expose different APIs), but the rule for
 * what counts as a block is language knowledge and lives here, derived from the generated command
 * list so a new measurement loop folds everywhere without another edit.
 */

import { measurementCommands } from './generated/syntax-data.js';

const blockOpeners: ReadonlySet<string> = new Set<string>(['if', 'loop', ...measurementCommands]);

const blockClosers: ReadonlySet<string> = new Set<string>(['endif', 'endloop']);

/**
 * The first whitespace-separated token of a line, which is the command name.
 */
function firstToken(line: string): string {
    return line.trim().split(/\s+/)[0] ?? '';
}

/**
 * Whether the line starts a foldable block: `if`, `loop`, or any measurement loop.
 */
export function opensBlock(line: string): boolean {
    return blockOpeners.has(firstToken(line));
}

/**
 * Whether the line ends a foldable block: `endif` or `endloop`.
 */
export function closesBlock(line: string): boolean {
    return blockClosers.has(firstToken(line));
}
